const PersonalData = {
    firstName: "Emmanuel",
    lastName: "Kipkirui",
    nickName: "< kip-dev >",
    mobNo: "+254756716711",
    email: "emmanuelkipkirui73@gmail.com",
    address: "Nairobi, Kenya",
    aboutMe: 
        "Hi Everyone, I am Emmanuel Kipkirui from Nairobi, Kenya. I am a full-stack software developer with expertise in both frontend and backend technologies. I specialize in JavaScript, Python, and frameworks like React.js, and Django. I have practical experience working with databases like MySQL, and I enjoy building robust web applications. I am eager to contribute to innovative projects while continuously growing my technical skills.",
    resumeLink: 'https://docs.google.com/document/d/12HzaaMYLK6qrCf16hjtsTBLqTxwhbWR2-j7Ycrm8wKY/edit?usp=sharing',
    imageUrl: ''
};

export const autoTypeData = [
    'Full-Stack Developer', 
    'React Enthusiast', 
    'Backend Developer', 
    'Frontend Developer',
    'Tech Innovator'
];

export default PersonalData;
